import React from 'react';
import styles from './Dashboard.module.css';

export default function MyOrders() {
  const mockOrders = [
    { id: 'ORD-1045', plan: 'Standard', sub: 'r/startups', status: 'In Progress', upvotes: '250/1000', comments: '5/20', date: 'Oct 20, 2026' },
    { id: 'ORD-1044', plan: 'Trust Karma', sub: 'Multiple', status: 'Active', upvotes: 'N/A', comments: 'N/A', date: 'Oct 15, 2026' },
    { id: 'ORD-1042', plan: 'Basic', sub: 'r/marketing', status: 'Completed', upvotes: '300/300', comments: '5/5', date: 'Sep 10, 2026' },
  ];

  const getStatusBadge = (status) => {
    switch(status) {
      case 'Active': return styles.badgeGreen;
      case 'In Progress': return styles.badgeAmber;
      case 'Completed': return styles.badgeGray;
      default: return styles.badgeGray;
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>My Orders</h1>
        <p className={styles.pageSubtitle}>View and manage your active and past campaigns.</p>
      </div>

      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Plan</th>
              <th>Subreddit</th>
              <th>Status</th>
              <th>Upvotes</th>
              <th>Comments</th>
              <th>Start Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {mockOrders.map(order => (
              <tr key={order.id}>
                <td style={{ fontWeight: '500' }}>{order.id}</td>
                <td>{order.plan}</td>
                <td>{order.sub}</td>
                <td>
                  <span className={`${styles.badge} ${getStatusBadge(order.status)}`}>
                    {order.status}
                  </span>
                </td>
                <td>{order.upvotes}</td>
                <td>{order.comments}</td>
                <td>{order.date}</td>
                <td>
                  <button className="btn btn-outline" style={{ fontSize: '12px', padding: '6px 12px' }}>View Details</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
